

window.addEventListener('load', function () {
  document.body.classList.add('loaded');
})

setTimeout(() => {
  document.body.classList.add('loaded');
}, 7000);





const lenis = new Lenis({
  smooth: true,
  lerp: 0.1
});

function raf(time) {
  lenis.raf(time);
  updateParallax();
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

const items = document.querySelectorAll('[data-speed]');

function updateParallax() {
  const vh = window.innerHeight;

  items.forEach(el => {
    const rect = el.getBoundingClientRect();

    // элемент далеко — не трогаем
    if (rect.bottom < 0 || rect.top > vh) return;

    /**
     * progress:
     * 0 — элемент только появился снизу
     * 1 — элемент полностью прошёл viewport
     */
    const progress =
      1 - (rect.top + rect.height) / (vh + rect.height);

    const speed = parseFloat(el.dataset.speed) || 0.3;

    // движение ВВЕРХ → минус
    const translateY = -progress * speed * 100;

    let rotate = 0;
    if (el.hasAttribute('data-rotate')) {
      const max = parseFloat(el.dataset.rotateMax) || 10;
      rotate = progress * max;
    }

    el.style.transform = `
    translate3d(0, ${translateY}px, 0)
    rotate(${rotate}deg)
  `;
  });
}


// let's get this party started
document.addEventListener('DOMContentLoaded', function () {

  setTimeout(() => {
    document.body.classList.add('loaded');
  }, 3500);








  // COUNTDOWN
  if (document.querySelector('.js_countdown') || document.querySelector('#js_countdown')) {


    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function words(x, thisWords) {
      if ((11 <= x && x <= 14) || (-14 <= x && x <= -11)) {
        return thisWords[2];
      } else {
        var lastDigit = x.toString().slice(-1);

        if (lastDigit == 1) {
          return thisWords[0];
        } else if (2 <= lastDigit && lastDigit <= 4) {
          return thisWords[1];
        } else {
          return thisWords[2];
        }
      }
    }


    function getServerDate() {
      var request = new XMLHttpRequest();
      request.open('GET', '/');
      request.send();
      request.onreadystatechange = function () {
        var dateString;
        if (request.readyState == 4) {
          dateString = request.getResponseHeader("Date");
          if (dateString.indexOf('GMT') === -1) {
            dateString += ' GMT';
          }
          var sDate = new Date(dateString);
          setTimer(sDate);
        }
      }
    }

    getServerDate();

    function setTimer(today) {
      console.log(today);

      //date_default_timezone_set('Etc/GMT+3');
      //var target_date = new Date().getTime() + (1000*3600*48); // установить дату обратного отсчета


      var days, hours, minutes, seconds;
      var dayWord, hourWord, minWord, secWord;
      var dayWords, hourWords, minWords, secWords;

      // var words;



      document.querySelectorAll('.js_countdown,#js_countdown').forEach(timer => {



        // var countdown = document.getElementById('js_countdown');
        var countdown = timer;


        var target_date = countdown.getAttribute('data-date') ? new Date(countdown.getAttribute('data-date')) : new Date(2025, 1, 21, 23, 59, 59);

        var current_date = today.getTime();


        (dayWords = ['день', 'дня', 'дней']),
          (hourWords = ['час', 'часа', 'часов']),
          (minWords = ['минута', 'минуты', 'минут']),
          (secWords = ['секунда', 'секунды', 'секунд']);

        if (today < target_date) {
          getCountdown();

          var refreshInterval = setInterval(function () {
            getCountdown();
          }, 15000); // 1000 — 1 sec
        } else if (today >= target_date) {
          countdown.innerHTML = `
<span class="count__item">
<span class="count__digit">00</span>
<span class="count__title">д.</span>
</span>
<span class="count__item">
<span class="count__digit">00</span>
<span class="count__title">ч.</span>
</span>
<span class="count__item">
<span class="count__digit">00</span>
<span class="count__title">м.</span>
</span>
`;
          // <span class="count__item">
          // <span class="count__digit">00</span>
          // <span class="count__title">с.</span>
          // </span>
        }


        function getCountdown() {
          current_date = current_date + 1000;
          var seconds_left = (target_date - current_date) / 1000;

          days = parseInt(seconds_left / 86400);
          seconds_left = seconds_left % 86400;

          hours = pad(parseInt(seconds_left / 3600));
          seconds_left = seconds_left % 3600;

          minutes = pad(parseInt(seconds_left / 60));
          seconds = pad(parseInt(seconds_left % 60));

          // dayWord = words(days, dayWords);
          // hourWord = words(hours, hourWords);
          // minWord = words(minutes, minWords);
          // secWord = words(seconds, secWords);
          dayWord = 'д.';
          hourWord = 'ч.';
          minWord = 'м.';
          secWord = 'с.';

          // dayWord = dayWords[2];
          // hourWord = hourWords[2];
          // minWord = minWords[2];
          // secWord = secWords[2];

          countdown.innerHTML = `
<span class="count__item">
<span class="count__digit">${days}</span>
<span class="count__title">${dayWord}</span>
</span>
<span class="count__item">
<span class="count__digit">${hours}</span>
<span class="count__title">${hourWord}</span>
</span>
<span class="count__item">
<span class="count__digit">${minutes}</span>
<span class="count__title">${minWord}</span>
</span>
`;

          // <span class="count__item">
          // <span class="count__digit">${seconds}</span>
          // <span class="count__title">${secWord}</span>
          // </span>

          if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {
            clearInterval(refreshInterval);
          }

        }
      });


    }
  }

  // ========================













  // Add .scrolled class to body when page is scrolled
  window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  });
  // check if page is scrolled
  if (window.scrollY > 0) {
    document.body.classList.add('scrolled');
  } else {
    document.body.classList.remove('scrolled');
  }


  // Close burger menu when clicking close buttons or pressing Esc
  document.querySelectorAll('.js_burger_close').forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      const burgerMenu = document.querySelector('.header__burger');
      if (burgerMenu && burgerMenu.hasAttribute('open')) {
        burgerMenu.removeAttribute('open');
      }
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const burgerMenu = document.querySelector('.header__burger');
      if (burgerMenu && burgerMenu.hasAttribute('open')) {
        burgerMenu.removeAttribute('open');
      }
    }
  });







});


// =================================================
// =================================================
// =================================================

